const BASE_URL = 'https://api.open-meteo.com/v1';

export const weatherService = {
    async getWeather(lat, long) {
        try {
            const response = await fetch(`${BASE_URL}/forecast?latitude=${lat}&longitude=${long}&current=temperature_2m,weather_code,wind_speed_10m&hourly=temperature_2m,precipitation_probability&timezone=auto`);
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching weather:', error);
            return null;
        }
    }
};
